import React, { useState } from "react";
import Layout from "../components/Layout";
import RapoarteConfigurator from "../components/RapoarteConfigurator";
import EvolutieClienti from "../components/EvolutieClienti";
import EvolutieComenzi from "../components/EvolutieComenzi";

const TABS = [
  ["erp", "ERP-nou"],
  ["erp-vechi", "ERP-vechi"],
  ["clienti-cumulat", "Clienti cumulat"],
  ["comenzi", "Comenzi validate financiar"],
  ["configurator", "Rapoarte configurator"],
];

export default function Evolutii() {
  const [tab, setTab] = useState("configurator");
  return (
    <Layout title="Evolutii">
      <div data-testid="evolutii-page">
        <div className="mb-5 flex gap-1 border-b border-slate-200">
          {TABS.map(([k, l]) => (
            <button
              key={k}
              data-testid={`evolutii-tab-${k}`}
              onClick={() => setTab(k)}
              className={`-mb-px border-b-2 px-4 py-2 text-sm font-medium ${tab === k ? "border-accent-500 text-slate-900" : "border-transparent text-slate-500 hover:text-slate-800"}`}
            >
              {l}
            </button>
          ))}
        </div>
        {tab === "erp" && <EvolutieClienti endpoint="/api/clienti-evolutie/erp-nou" testid="evolutii-erp-nou" />}
        {tab === "erp-vechi" && <EvolutieClienti endpoint="/api/clienti-evolutie/erp-vechi" testid="evolutii-erp-vechi" />}
        {tab === "clienti-cumulat" && <EvolutieClienti endpoint="/api/clienti-evolutie/cumulat" testid="evolutii-clienti-cumulat" />}
        {tab === "comenzi" && <EvolutieComenzi />}
        {tab === "configurator" && <RapoarteConfigurator />}
      </div>
    </Layout>
  );
}
